import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { html } from "js-beautify";

@Component({
    selector: 'app-example',
    templateUrl: './example.component.html',
    styleUrls: ['./example.component.scss']
})
export class ExampleComponent implements OnInit {

    @ViewChild('content', { static: true }) content;
    @Input() containerType: string = '';
    @Input() hideCompiled: boolean = false;
    @Input() alwaysShow: boolean = false;
    @Input() onlyShowExample: boolean = false;
    @Input() code: string;

    // Public variables
    public isCodeVisible: boolean = false;
    public html: string;

    constructor() {
    }

    ngOnInit() {
        const config = {
            indent_size: 4,
            wrap_line_length: 80,
            inline: [],
            wrap_attributes: 'force-aligned'
        };
        this.html = this.code || html(this.content.nativeElement.innerHTML, config);
        this.html = this.html.split(/\s*_ngcontent.*=""\s*/).join(' '); // Removes all the ngcontent garbage in the html.
    }

    public toggleVisibility(): void {
        this.isCodeVisible = !this.isCodeVisible;
    }
}
